import React, { useEffect } from "react";
import { toast } from "react-toastify";
import { getDoctorInfoByAlias } from "../../network/api/users/doctor/doctor";
import { useLoader } from "../../context/LoadingContext";
import DoctorNotFound from "../Booking/components/NotFound/NotFound";
import FullScreenLoader from "../../components/Loading";
import DoctorNavbar from "./components/Navbar/Navbar";
import HeroSection from "./components/Hero/Hero";
import { IDoctor } from "../../dto/interfaces";
import ServicesSection from "./components/Services/ServiceSection";
import AboutDoctorSection from "./components/About/AboutSection";
import ContactUs from "./components/ContactUs/ContactSection";
import { BookingSection } from "./components/Booking/BookingSection";
import Footer from "./components/Footer/Footer";
import { useParams } from "react-router-dom";
import handleApiCall from "../../../../admin/src/utils/HandleApiCall";

const BookingLayout = () => {
    const { alias } = useParams<{ alias: string }>();
    const [doctor, setDoctor] = React.useState<IDoctor | null>(null);
    const { setLoading } = useLoader();

    const [state, setState] = React.useState<"idle" | "loading" | "loaded">("idle");

    async function getDoctor() {
        if (!alias) {
            return;
        }

        try {
            setLoading(true);
            setState("loading");
            const res = await getDoctorInfoByAlias(alias);
            setDoctor(res);
        } catch (error) {
            toast.error(error.response.data.message);
        } finally {
            setLoading(false);
            setState("loaded");
        }
    }

    useEffect(() => {
        getDoctor();
    }, []);

    if (state === "loading") {
        return <FullScreenLoader />;
    }

    if (!doctor && state === "loaded") {
        return <DoctorNotFound />;
    }

    return (
        <>
            {doctor && (
                <>
                    <DoctorNavbar doctor={doctor} />
                    <HeroSection doctor={doctor} />
                    <ServicesSection doctor={doctor} />
                    <AboutDoctorSection doctor={doctor} />
                    <BookingSection doctor={doctor} />
                    <ContactUs doctor={doctor} />
                    <Footer doctor={doctor} />
                </>
            )}
        </>
    );
};

export default BookingLayout;
